  /**
   * @param {Phaser.Scene} scene
   * @param {string} texture
   * 
  */
 // this is how to add autofill in a separate function
export const createButton = (
  scene,
  width,
  height,
  texture,
  scale,
  callback
) => {
  const button = scene.add
    .image(width, height, texture)
    .setScale(scale)
    .setInteractive()
    .on("pointerover", () => {
      button.setTint(0xb0adad);
    })
    .on("pointerout", () => {
      button.setTint(0xffffff);
    })
    .on("pointerdown", () => {
      button.setTint(0x807c7c);
      scene.time.delayedCall(200, () => {
        button.setTint(0xb0adad);
        callback();
      });
    });
  return button; // to make it as it is created at the same file
};
